<template>
    <div class="container">
        <h2>
            Your <strong>monthly payments</strong> broken down
        </h2>
        <div class="monthly-payments-table">
            <ul>
                <li v-for="(yearData, year) in amortizationBreakdown" :key="year" :class="{active: isActive[year]}" class="trigger" @click="toggleActive(year)">
                    {{ year }}
                    <div class="table-responsive">
                        <table class="table table-striped table-hover table-condensed">
                            <thead>
                                <tr>
                                    <th width="17%">Month</th>
                                    <th width="17%">Payment</th>
                                    <th width="16%">Principal</th>
                                    <th width="17%">Interest Paid</th>
                                    <th width="17%">Total Interest</th>
                                    <th width="16%">Balance</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(monthData, index) in yearData" :key="index">
                                    <td>{{ monthData.namedMonth }}</td>
                                    <td>{{ monthData.payment }}</td>
                                    <td>{{ monthData.principal }}</td>
                                    <td>{{ monthData.interestPaid }}</td>
                                    <td>{{ monthData.totalInterest }}</td>
                                    <td>{{ monthData.balance }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import AmortizationBreakdownHelper from '../helpers/amortization-breakdown';

    export default {
        data() {
            return {
                isActive: {},
            };
        },
        props: {
            loanAmount: {
                default: 0,
            },
            loanTermInYears: {
                default: 0,
            },
            interestRate: {
                default: 0,
            },
        },
        computed: {
            amortizationBreakdown() {
                return AmortizationBreakdownHelper.amortizationBreakdown(this.loanAmount, this.loanTermInYears, this.interestRate);
            },
        },
        methods: {
            toggleActive(year) {
                this.isActive[year] = !this.isActive[year];
            },
        },
    };
</script>
<style lang="scss">
@import "../../assets/styles/variables";
#lt-yantr {
    .monthly-payments-table {
        margin: 0;
        .trigger {
            color: #02adf2;
            font-size: 27px;
            font-weight: 300;
            padding: 20px 0;
            cursor: pointer;
            transition: all .4s;
            &:before {
                font-family: "lt5";
                content: "\e97d";
                vertical-align: top;
            }
            &.active {
                &:before {
                    font-family: "lt5";
                    content: "\e97e";
                    vertical-align: top;
                }
                .table-responsive {
                    visibility: visible;
                    opacity: 1;
                    max-height: 100%;
                }
            }
            @media #{$mob-portrait-view} {
                font-size: 17px;
                padding: 10px 0;
            }
        }
        ul{
            margin: 0;
            padding: 0;
            li {
                list-style: none;
                margin: 0;
                padding: 10px 0;
                border-top: solid #eee 1px;
                .trigger {
                    font-weight: 300;
                    padding: 10px 0 13px;
                    cursor: pointer;
                    transition: all .4s;
                }
                .table-responsive {
                    visibility: hidden;
                    opacity: 0;
                    overflow: auto;
                    max-height: 0;
                    transition: all 0.5s;
                    @media #{$mob-landscape-view} {
                        border: none;
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
</style>
